export default __webpack_public_path__ + "static/media/1409.4ea38a1d.png";